import type { Template } from "@/types";

export const PO_06_H2_V4: Template[] = [
    {
        id: "po-06-h2v4-01",
        name: "PO 01 - H2V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h2_v4_01.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 51, y: 242, width: 272, height: 433, rotation: 0, imageRotation: 0 },
            { id: "2", x: 331, y: 242, width: 299, height: 212, rotation: 0, imageRotation: 0 },
            { id: "3", x: 331, y: 462, width: 299, height: 213, rotation: 0, imageRotation: 0 },
            { id: "4", x: 739, y: 175, width: 382, height: 565, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1129, y: 175, width: 189, height: 279, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1129, y: 462, width: 189, height: 278, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h2v4-02",
        name: "PO 02 - H2V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h2_v4_02.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 151, y: 176, width: 386, height: 565, rotation: 0, imageRotation: 0 },
            { id: "2", x: 752, y: 176, width: 414, height: 279, rotation: 0, imageRotation: 0 },
            { id: "3", x: 752, y: 463, width: 414, height: 278, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1174, y: 176, width: 125, height: 183, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1174, y: 367, width: 125, height: 183, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1174, y: 558, width: 125, height: 183, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h2v4-03",
        name: "PO 03 - H2V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h2_v4_03.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 54, y: 242, width: 286, height: 433, rotation: 0, imageRotation: 0 },
            { id: "2", x: 348, y: 242, width: 286, height: 213, rotation: 0, imageRotation: 0 },
            { id: "3", x: 348, y: 463, width: 286, height: 212, rotation: 0, imageRotation: 0 },
            { id: "4", x: 808, y: 242, width: 294, height: 433, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1110, y: 242, width: 143, height: 213, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1110, y: 463, width: 143, height: 212, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h2v4-04",
        name: "PO 04 - H2V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h2_v4_04.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 71, y: 96, width: 545, height: 358, rotation: 0, imageRotation: 0 },
            { id: "2", x: 71, y: 462, width: 545, height: 358, rotation: 0, imageRotation: 0 },
            { id: "3", x: 758, y: 96, width: 269, height: 358, rotation: 0, imageRotation: 0 },
            { id: "4", x: 758, y: 462, width: 269, height: 358, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1035, y: 96, width: 268, height: 358, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1035, y: 462, width: 268, height: 358, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h2v4-05",
        name: "PO 05 - H2V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h2_v4_05.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 71, y: 96, width: 269, height: 358, rotation: 0, imageRotation: 0 },
            { id: "2", x: 348, y: 96, width: 269, height: 358, rotation: 0, imageRotation: 0 },
            { id: "3", x: 71, y: 462, width: 546, height: 358, rotation: 0, imageRotation: 0 },
            { id: "4", x: 758, y: 96, width: 545, height: 358, rotation: 0, imageRotation: 0 },
            { id: "5", x: 758, y: 462, width: 269, height: 358, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1035, y: 462, width: 268, height: 358, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h2v4-06",
        name: "PO 06 - H2V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h2_v4_06.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 56, y: 171, width: 574, height: 365, rotation: 0, imageRotation: 0 },
            { id: "2", x: 56, y: 543, width: 138, height: 203, rotation: 0, imageRotation: 0 },
            { id: "3", x: 202, y: 543, width: 138, height: 203, rotation: 0, imageRotation: 0 },
            { id: "4", x: 348, y: 543, width: 137, height: 203, rotation: 0, imageRotation: 0 },
            { id: "5", x: 493, y: 543, width: 137, height: 203, rotation: 0, imageRotation: 0 },
            { id: "6", x: 741, y: 263, width: 579, height: 391, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "po-06-h2v4-07",
        name: "PO 07 - H2V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h2_v4_07.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 57, y: 170, width: 187, height: 284, rotation: 0, imageRotation: 0 },
            { id: "2", x: 252, y: 170, width: 380, height: 284, rotation: 0, imageRotation: 0 },
            { id: "3", x: 57, y: 462, width: 187, height: 284, rotation: 0, imageRotation: 0 },
            { id: "4", x: 252, y: 462, width: 186, height: 284, rotation: 0, imageRotation: 0 },
            { id: "5", x: 446, y: 462, width: 186, height: 284, rotation: 0, imageRotation: 0 },
            { id: "6", x: 741, y: 263, width: 579, height: 391, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "po-06-h2v4-08",
        name: "PO 08 - H2V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h2_v4_08.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 0, y: 0, width: 687, height: 916, rotation: 0, imageRotation: 0 },
            { id: "2", x: 760, y: 178, width: 404, height: 276, rotation: 0, imageRotation: 0 },
            { id: "3", x: 760, y: 462, width: 404, height: 276, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1172, y: 178, width: 121, height: 182, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1172, y: 368, width: 121, height: 181, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1172, y: 557, width: 121, height: 181, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h2v4-09",
        name: "PO 09 - H2V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h2_v4_09.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 56, y: 292, width: 119, height: 162, rotation: 0, imageRotation: 0 },
            { id: "2", x: 56, y: 462, width: 119, height: 162, rotation: 0, imageRotation: 0 },
            { id: "3", x: 183, y: 292, width: 119, height: 162, rotation: 0, imageRotation: 0 },
            { id: "4", x: 183, y: 462, width: 119, height: 162, rotation: 0, imageRotation: 0 },
            { id: "5", x: 310, y: 292, width: 501, height: 332, rotation: 0, imageRotation: 0 },
            { id: "6", x: 819, y: 292, width: 501, height: 332, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h2v4-10",
        name: "PO 10 - H2V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h2_v4_10.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 0, y: 248, width: 545, height: 420, rotation: 0, imageRotation: 0 },
            { id: "2", x: 553, y: 248, width: 130, height: 206, rotation: 0, imageRotation: 0 },
            { id: "3", x: 553, y: 462, width: 130, height: 206, rotation: 0, imageRotation: 0 },
            { id: "4", x: 691, y: 248, width: 130, height: 206, rotation: 0, imageRotation: 0 },
            { id: "5", x: 691, y: 462, width: 130, height: 206, rotation: 0, imageRotation: 0 },
            { id: "6", x: 829, y: 248, width: 545, height: 420, rotation: 0, imageRotation: 0 },
        ],
    },
];

